import HBModal from "../HBModal";
import styles from "./index.module.less";

const ContactServiceQRCodeModal = ({ visible, onClose }) => {
  return (
    <HBModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={480}
      centered
      className={styles.modal}
    >
      <div className={styles.content}>
        <p className={styles.title}>升级请联系专属客服</p>
        <p className={styles.description}>扫码添加专属客服</p>
      </div>
      <img
        className={styles.qrcode}
        src="https://cdn.dancf.com/fe-assets/img/beebc67e6f6350998880e1d5a86818c7.png"
        alt="企业资源二维码"
      />
    </HBModal>
  );
};

export default ContactServiceQRCodeModal;
